<template>
  <v-app>
    <v-content>
      <ToolBar v-if="$cookie.get('x-access-token')"/>
      <router-view/>
    </v-content>
  </v-app>

</template>

<script>
import ToolBar from './components/ToolBar'

export default {
  name: 'App',
  components: {
    ToolBar
  },
  data () {
    return {
      drawer: null,
       items: [
         { title: 'Home', icon: 'dashboard' },
         { title: 'About', icon: 'question_answer' }
       ]
    }
  }
}
</script>

<style lang="css" src="../public/style.css">
</style>
